import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router"
import SettingsOverviewPage from "@/app/settings/overview/page"

function SettingsOverviewLayout() {
  const location = useLocation()

  if (location.pathname === "/settings/overview") {
    return <SettingsOverviewPage />
  }

  return <Outlet />
}

export const Route = createFileRoute("/settings/overview")({
  component: SettingsOverviewLayout,
})
